module.exports = __webpack_public_path__ + "images/my-integral-icon-detail.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/my-integral-icon-detail.png
// module id = 887
// module chunks = 121